import React, { PureComponent } from "react";
import styles from "./Goto.local.scss";
import _ from "i18n";

export default class Goto extends PureComponent {
  copyUrl = e => {
    document.getElementById("media-url").select();
    document.execCommand("copy");
    document.getElementById("copy-url").textContent = _("Copied");
    setTimeout(() => {
      document.getElementById("copy-url").textContent = _("Copy");
    }, 2000);
  };

  render() {
    const { url } = this.props;
    return (
      <div className={styles.goto}>
        <input id="media-url" type="text" defaultValue={url} />
        <span id="copy-url" onClick={this.copyUrl.bind(this)}>
          {_("Copy")}
        </span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Reveal/MediaViewer/Goto/index.js